import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const newyorkyankees_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "newyorkyankees_upgrades",
  TEAM_FULL_NAME: "New York Yankees",
  BROWSER_TITLE: "New York Yankees Upgrades",
  CLIENT_ID: "f6bde69252f3.seasonshare.nyyreg-nyyankees.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#132448",
    COLORS_SECONDARY: "#0C2340",
    IS_INTERCOM_ENABLED: false,
    IS_BALLPARK_APP: true,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },
    DEFAULT_APP_ROUTE: routes.landing,
    FOOTER: {
      BACKGROUND_COLOR: "#132448",
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()} MLB Advanced Media, L.P. All rights reserved`,
    },
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      IS_EXPANDED_CARD: true,
    },

    HIDE_PASSES: true,
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
      NEXT_GAME_LABEL: "Today's Game",
      HIDE_EVENT_LOGO: true,
    },
    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Purchase Confirmed!",
        DESCRIPTION: () =>
          "Thank you for your purchase. You have successfully purchased an upgrade for today's Yankees game. Your tickets are now available in the MLB Ballpark app.",
      },
    },
    ZERO_STATE: {
      TITLE: "No Available Upgrades",
      DESCRIPTION:
        "You must have a valid game ticket to today's game in order to participate in this exclusive opportunity. Offer valid for select, non-premium seating areas.",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
  },

  IMAGES: {
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB-3/Yankees-Assets/NYY_26_GamedayUpgradeExp_1920x450.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Yankees%20Ballpark/NYY_26_GamedayUpgradeExp_375x550%201.jpg",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/NY Yankees Ballpark/BallparkPass_BGImage_3_1920x1080.png",
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/NYY-3.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
